import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  pivot(event) {
    const button = event.currentTarget
    const url = button.dataset.url
    const now = new Date()
    const pad = n => String(n).padStart(2, '0')
    const startTime = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`

    const form = document.createElement("form")
    form.method = "post"
    form.action = url

    const methodInput = document.createElement("input")
    methodInput.type = "hidden"
    methodInput.name = "_method"
    methodInput.value = "patch"
    form.appendChild(methodInput)

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const csrfInput = document.createElement("input")
    csrfInput.type = "hidden"
    csrfInput.name = "authenticity_token"
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    const timeInput = document.createElement("input")
    timeInput.type = "hidden"
    timeInput.name = "start_time"
    timeInput.value = startTime
    form.appendChild(timeInput)

    document.body.appendChild(form)
    form.submit()
  }
}
